import { set, toggle } from '@/utils/vuex'

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  setItems: set('list'),
  toggleMenu: toggle('menu'),
  toggleMini: toggle('mini'),
  toggleChat: toggle('chat'),
  toggleTemplate: toggle('template'),
  toggleEdit: toggle('edit'),
  togglePreview: toggle('preview'),
  setMenu: set('menu'),
  setMini: set('mini'),
  setChat: set('chat'),
  setTemplate: set('template'),
  setPreview: set('preview'),
  setEdit: set('edit'),
  setMessage: set('message'),
  setDeeplink (state, deeplink) {
    state.deeplink = deeplink
  },
}
